module.exports = __webpack_public_path__ + "static/img/categories.7ce9420.png";